/**
* Copyright Zendesk, Inc.
*
* Use of this source code is governed under the Apache License, Version 2.0
* found at http://www.apache.org/licenses/LICENSE-2.0.
*/
import React__default, { forwardRef, useEffect } from 'react';
import '../styled/StyledBackdrop.js';
import '../styled/StyledBody.js';
import { StyledClose } from '../styled/StyledClose.js';
import '../styled/StyledFooter.js';
import '../styled/StyledFooterItem.js';
import '../styled/StyledHeader.js';
import '../styled/StyledDangerIcon.js';
import '../styled/StyledModal.js';
import '../styled/StyledTooltipModalBackdrop.js';
import '../styled/StyledTooltipWrapper.js';
import '../styled/StyledTooltipModal.js';
import '../styled/StyledTooltipModalTitle.js';
import '../styled/StyledTooltipModalBody.js';
import '../styled/StyledTooltipModalFooter.js';
import '../styled/StyledTooltipModalFooterItem.js';
import '../styled/StyledTooltipModalClose.js';
import '../styled/StyledDrawerModal.js';
import '../styled/StyledDrawerModalHeader.js';
import '../styled/StyledDrawerModalClose.js';
import '../styled/StyledDrawerModalBody.js';
import '../styled/StyledDrawerModalFooter.js';
import '../styled/StyledDrawerModalFooterItem.js';
import { useText } from '@zendeskgarden/react-theming';
import { useModalContext } from '../utils/useModalContext.js';
import SvgXStroke from '../node_modules/@zendeskgarden/svg-icons/src/16/x-stroke.svg.js';

const Close = forwardRef((props, ref) => {
  const {
    getCloseProps,
    setIsCloseButtonPresent
  } = useModalContext();
  useEffect(() => {
    setIsCloseButtonPresent(true);
    return () => setIsCloseButtonPresent(false);
  });
  const ariaLabel = useText(Close, props, 'aria-label', 'Close modal');
  return React__default.createElement(StyledClose, Object.assign({}, getCloseProps({
    ...props,
    'aria-label': ariaLabel
  }), {
    ref: ref
  }), React__default.createElement(SvgXStroke, null));
});
Close.displayName = 'Close';

export { Close };
